exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*color: #d9d1cf; font-family: HelveticaNeueW01-75Bold, Helvetica, Arial, sans-serif; font-size: 12px*/\na.bootomFooter[data-v-6c07c36f]:hover {\n    color: var(--theme-primary);\n color: #273238 !important\n}\n.bootomFooter a[data-v-6c07c36f], .bootomFooter a[data-v-6c07c36f]:active  {\n    color: var(--theme-primary);\n color: #273238 !important\n}\n.bootomFooter a[data-v-6c07c36f]:hover {\n    text-decoration: underline;\n    color:#fff;\n}\n#applicationFooter[data-v-6c07c36f]{\n    bottom: 0;\n padding: 13px 13px 13px 200px;\n height: initial;\n background: #fff;\n color: #273238 !important;\n}\n@media (max-width: 767px) {\n#applicationFooter[data-v-6c07c36f]{\n padding-left: 15px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6c07c36f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer/footer.vue
// module id = 604
// module chunks = 1